import getSymbolFromCurrency from 'currency-symbol-map';

export const formatMoney = (x: { value: string; currency: string }, showCurrencyCode: boolean = true): string => {
    return `${getSymbolFromCurrency(x.currency)}${x.value}${showCurrencyCode ? ' ' + x.currency : ''}`
}